<template>
  <div id="app">
    <router-view v-if="server_info != null"/>
  </div>
</template>

<script>

import 'jquery/dist/jquery.min.js'
import 'uikit/dist/css/uikit.min.css'
import 'uikit/dist/js/uikit.min.js'
import 'uikit/dist/js/uikit-icons.min.js'
import {mapActions,mapGetters} from 'vuex'

export default {
  name: 'App',
  components: {
  },
  created(){
    this.fetchServerInfo();
  },
  computed:{
    ...mapGetters(['server_info'])
  },
  methods:{
    ...mapActions(['fetchServerInfo']),
    domain_is(dmn){
      return (window.location.href.split('/')[2].match(dmn)) ? true : false
    },
  }
}
</script>

<style>

  @import "../node_modules/uikit/dist/css/uikit.min.css";

  .vdp-datepicker input{
    display: none;
  }
  .pd-program-info{
    margin-top: 20px;
    font-family: Avenir-medium;
  }

  .schedule-header{
    border-bottom: unset;
    padding-bottom: unset;
    right: 0;
    left: 0;

    position: -webkit-sticky; /* Safari */
    position: sticky;
    top: -1px;
    z-index: 999;
    background: #f7eeca
  }
  #schedule-app-main-div{
    /*max-width: 1260px;*/
    margin-left: auto;
    margin-right: auto;
  }
  .light-green a-za-z-ul-program-title{
    font-family: Avenir-medium;
    font-size: 20pt;
    cursor: pointer;
  }

  .a-z-ul-program-title:hover{
    background-color: white;
    cursor:pointer;
  }
  .uk-modal{
    background: rgba(0,0,0,.75);
  }
  .uk-button-small{
    padding: 0 3px;
    font-size: 13px;
  }
  .uk-grid{
    text-align: left;
  }
  .reset-filters-box{
    height: 12px;
    float: right;
    max-width: 75px;
    margin-top: -23px;
  }
  .search-results-channel-separator{
    background-color: #4c6464;
    color: white;
    font-size: 25px;
    text-align: left;
    padding-left: 28px;
    margin-bottom: 0px;
    padding-top: 10px;
    padding-bottom: 10px;

    max-width: 1180px;
    margin-left: auto;
    margin-right: auto;

  }
  .pbs-schedule-grid-title {
    font-size: 20px;
    font-weight: bold;
    font-family: Avenir-medium;
    color: #01aeb4 !important;
    margin-top: 0px;
  }

  .pbs-schedule-grid-title-search {
    font-size: 30px;
    font-weight: bold;
    font-family: Avenir-heavy;
    color: #01aeb4 !important;
    margin-top: 10px;
  }
  .pbs-schedule-grid-sub-title{
    font-size: 16px;
    color: black;
    font-weight: normal;
    font-family: Avenir-medium;
  }

  .pbs-search-grid-title{
    margin-top: 20px;
    margin-bottom: 20px;
  }
  .size-24 {
    font-size: 12px;
    line-height: unset;
  }
  .change-date{
    display: none;
  }
  .calendar-container{
    padding-top: 10px;
  }
  .channel-dropdown-selector{
    min-width: 175px;
    margin-left: 30px;
    max-width: 300px;
  }
  .search-box-container{
    min-width: 275px;
    margin-left: 30px;
    margin-top: 20px;
    margin-left:auto;
    margin-right:auto;
  }
  .view-dropdown-selector{
    min-width: 175px;
    margin-left: auto;
    margin-right: auto;
  }
  .uk-accordion-title:before {
    margin-right: 0px;
  }
  .date-forward-date-back{
    width: 170px;
    margin-top: 20px;
    margin-left: auto;
    margin-right: auto;
  }
  .calendar-icon-container{
    width: 30px;
    margin-top: auto;
    margin-right: auto;
  }
  .program-details-image-container{
    padding-right: 35px;
    padding-left: 45px;
    padding-bottom: 25px;
  }
  .program-details-desc-container{
    text-align: justify;
    width: 98%; float: left;
    padding-right: 0px;
    padding-left: 5px;
  }
  .program-details-modal-container{
     overflow-y: auto;
  }
  .search-container-button{
    width: 80px;margin-left:-90px;background-color: black;line-height: 35px;border: 1px solid #555;padding-left:11px;
  }
  .pbs-schedule-grid-details-content {
    min-width: 290px;
    margin-left: 10px;
    padding-left: 34px;
    padding-rigth: 20px;
  }

  .schedule-channel-selector-input{
    max-width: 420px;
    width: 100%;
    margin-top: 10px;
    margin-left: 5px;
    color:black;
    padding-right: 50px;
    padding-left: 5px;

    min-width: 390px;height: 44px;padding-top: 8px;margin-top: 5px; padding-right: 65px;
  }
  .schedule-channel-selector{
    min-width: 190px;
    margin-top: 5px;


    /*appearance: none;
    background: url(https://www.pbs12.org/images/schedule/right-date-arrow.svg) right / 20px no-repeat #fff;*/
    padding-right: 20px;
    background: url(https://www.pbs12.org/images/schedule/search-icon.svg) 99%/33px no-repeat #fff;

  }

  .uk-accordion-title:before {
    margin-right:0px;
  }

  .search-selector-label-view{
    margin-left: 107px;
    margin-top: 20px;
    color: black;
    font-weight: bold;
    font-size: 13px;
  }
  .search-selector-label{
    color: black;
    font-weight: bold;
    font-size: 13px;
    margin-left: 152px;
  }
  .schedule-date-heading-container{
    text-transform: uppercase;
    font-weight: bold;
    color: black;
    font-size: 12px;
    line-height: 0px;
  }
  .uk-padding-small {
    padding: 0px;
  }
  .schedule-date-heading {
    margin-bottom: 0px;
  }
  .uk-search-default{
    display: block;
  }
  .uk-accordion{
    margin-top: 0px;
  }
  .search-box-div{
    max-width: 260px;width: 100%;text-align: center;margin-left: auto;margin-right: auto;
  }
  .reset-filters-button{
    color: #01aeb4;font-size: 14px;float:right;margin-right: 17px;
  }

  .calendar-button{
    /*background-image: url("/images/schedule/calendar.svg");*/
    background-repeat: no-repeat;
    width: 1px;
    height: 1px;
  }

  .pbs-schedule-grid-details {
    max-width: 720px;
    margin-left: auto;
    margin-right: auto;
    padding-left: 20px;
  }

  .schedule-date-heading img {margin-top: 1px;}

  @supports( display:grid ) {
    @media screen and (min-width:700px) {
    }
  }


  .vdp-datepicker__calendar{
    margin-left: 82px;
    font-size: 18px;
    margin-top: 15px;
  }

  .light-green {
    color: #01aeb4 !important;
  }
  .uk-accordion>:nth-child(n+2) {
    margin-top: 0px;
  }

  .uk-button{
    border: 2px solid rgb(1, 174, 180);
    color: rgb(1, 174, 180);
    background: transparent;
    border-radius: 15px;
    text-transform: lowercase;
    padding-left: 20px;
    padding-right: 20px;
    line-height: 23px;
    font-size: 17px;
  }
  .uk-accordion-title::before {
      content: "";
      width: 26px;
      height: 26px;
      background-image: url('/images/schedule/toggle-open.svg');
      background-repeat: no-repeat;
      background-position: 50% 50%;
      box-shadow: inset 0 0 0 2px rgb(1,174,180);
      border-radius: 100px;
      border: 0;
   }
   .uk-open>.uk-accordion-title::before {
     background-image: url('/images/schedule/toggle-close.svg');
     width: 26px;
     height: 26px;
   }
    .view-earlier-bar{
      margin-left:auto;margin-right:auto;background-image: url('/images/schedule/view-earlier-clock.svg');width: 150px;height: 1.2em;background-repeat: no-repeat;background-position: 0% 50%;padding-left: 5px;line-height: 19px;margin-top: 4px;
    }
    .view-next-bar{
      margin-left:auto;margin-right:auto;background-image: url('/images/schedule/right-date-arrow.svg');
      background-repeat: no-repeat;
      width: 160px;
      height: 13px;
      background-position: 100% 50%;
      line-height: 14px;
      margin-top: 6px;
      /*width: 175px;height: 1.0em;background-repeat: no-repeat;background-position: 100% 50%;padding-left: 5px;line-height: 15px;margin-top: 4px;*/
    }
    .view-next-bar:hover, .view-earlier-bar:hover{
      cursor: pointer;
    }

  /*.uk-button-primary:active,
  .uk-button-primary.uk-active {
    background-color: black;
    color: #fff;
  }
  / * Focus * /
  .uk-radio:checked:focus,
  .uk-checkbox:checked:focus,
  .uk-checkbox:indeterminate:focus {
    background-color: black;
  }*/
  /* Hover + Focus */
  .uk-button-primary:hover,
  .uk-button-primary:focus {
    background-color: #00aeb494;
    color: #fff;
  }
  .az-az-letters{
    max-width: 1260px;
    margin-left: auto;
    margin-right: auto
  }
  .a-z-programs-ul{
    /*max-width: 1400px;*/
    margin-left: auto;
    margin-right: auto;
  }
  .a-z-programs-ul >li{
    padding-left: 100px;
    background:   #f8f5ec;
    margin-top: 0;
    padding-bottom: 15px;
    padding-top: 15px;
  }
  .a-z-programs-ul >li>:nth-child(n+2){
    margin-top: 0;
  }
  @media only screen and (max-width: 639px) {
    .a-z-programs-ul >li{
     padding-left: 10px;
    }
  }

  .multi-schedule-main-div{
    max-width: 1180px;
    width: 100%;
    margin-left: auto;
    margin-right: auto
  }
  .schedule-main-div{
    width: 100%;
    /*max-width: 1260px;*/
    margin-left: auto;
    margin-right: auto;
    padding-left: 0;
  }
  .all-air-dates-bar{
    background: white;max-width: 1330px;margin-left: auto;margin-right: auto;
    padding-left:0;
  }
  .uk-accordion-title{
    font-size: 18px;
  }

  .schedule-li-content{
    max-width: 1260px;
    margin-left: auto;
    margin-right: auto;
  }
  .uk-accordion-title:before{
    width: 30px;
    height: 30px;
    margin-top: 7px;
    margin-right: 40px;
    margin-right: 0px;
  }
  .uk-open>.uk-accordion-title:before{
    width: 30px;
    height: 30px;
  }

  /** NEW **/

  .gridcenter1200 {
    max-width: 1140px;
    margin: auto;
    padding: 0 5px;

  }

  .uk-tab>.uk-active>a {
    color: rgb(1 174 180);
    border-color: rgb(1 174 180);
    font-family: Avenir-heavy;
    border-top: 4px solid rgb(1 174 180);
  }

  .uk-tab::before {
    border-bottom: 0px solid red;
  }

  .schedule-row {
    border-top: 1px solid rgba(0,0,0,.25);
  }
  .schedule-row:hover {
    border-top: 1px solid rgba(0,0,0,.5);
    background-color: #f7f5ed;
  }

  .x-button {
    width: 30px;
    height: 30px;
    background-image: url(/images/schedule/toggle-open.svg);
    background-repeat: no-repeat;
    background-position: 50% 50%;
    -webkit-box-shadow: inset 0 0 0 2px rgb(1 174 180);
    box-shadow: inset 0 0 0 2px rgb(1 174 180);
    border-radius: 100px;
    border: 0;
    float: right;
    margin-left: 10px;
    cursor:pointer;
  }
  .pbs-play-button {
    width: 30px;
    height: 30px;
    background-image: url(/images/schedule/pbs-play-button.svg);
    background-repeat: no-repeat;
    background-position: 50% 50%;
    -webkit-box-shadow: inset 0 0 0 2px rgb(1 174 180);
    box-shadow: inset 0 0 0 2px rgb(1 174 180);
    border-radius: 100px;
    border: 0;
    float: right;
    margin-left: 10px;
  }
  .minus-button {
    width: 30px;
    height: 30px;
    background-image: url(/images/schedule/toggle-close.svg);
    background-repeat: no-repeat;
    background-position: 50% 50%;
    -webkit-box-shadow: inset 0 0 0 2px rgb(1 174 180);
    box-shadow: inset 0 0 0 2px rgb(1 174 180);
    border-radius: 100px;
    border: 0;
    float: right;
    margin-left: 10px;
    cursor:pointer;
  }

  .button-schedule-top {
    color: rgb(1, 174, 180);
    background-color: white;
    border-radius: 100px;
    text-align: center;
    height: 30px;
    line-height: 28px;
    padding: 2px 12px 0;
    font-size: 14px;
    width: 100%;
    font-family: Avenir-heavy;
    cursor:pointer;
  }

  .button-schedule {
    box-shadow: inset 0 0 0 2px rgb(1, 174, 180);
    color: rgb(1, 174, 180);
    border-radius: 100px;
    text-align: center;
    height: 30px;
    line-height: 28px;
    padding: 2px 12px 0;
    font-size: 14px;
    float: right;
    width: 120px;
    width: 100%;
    margin-left: 10px;
    margin-bottom: 5px;
    font-family: Avenir-heavy;
    cursor:pointer;
  } @media only screen and (max-width: 959px) {
    .button-schedule {
      width: 140px;
    }
  }@media only screen and (max-width: 959px) {
    .button-float-xs {
      float: left;
      margin-bottom: 0;
    }
  }
  @media only screen and (max-width: 959px) {
    .button-float-m-margin {
      margin-left: 5px;
    }
  }
  @media only screen and (max-width: 639px) {
    .button-float-m-margin {
      margin-left: 5px;
    }
  }

  .button-watch-now {
    width: calc(100% - 40px);
    margin-bottom: 0;
    margin-left: 0;
  }@media only screen and (max-width: 639px) {
    .button-watch-now {
      width: 120px;
    }
  }
  .button-watch-now:hover{
    text-decoration: none;
    color: #01aeb4;
  }

  .pbs-schedule-grid-time2 {
    text-align: right;
    color: black;
    font-family: Avenir-medium;
    font-size: 24px;
    margin-top: 3px;
  }@media only screen and (max-width: 959px) {
      .pbs-schedule-grid-time2 {
        font-size: 18px;
      }
    }

  .pbs-schedule-grid-time-xs {
    color: black;
    font-family: Avenir-medium;
    font-size: 18px;
    line-height: 36px;
    text-align: left;
    margin-left: 5px;
  }

  .pbs-schedule-grid-title2 {
    font-size: 30px;
    font-weight: bold;
    line-height: 1.1;
    font-family: Avenir-medium;
    color: #01aeb4 !important;
    margin-top: 0px;
  }@media only screen and (max-width: 959px) {
      .pbs-schedule-grid-title2 {
        font-size: 24px;
      }
    }

  .pbs-schedule-grid-subtitle2 {
    font-size: 22px;
    line-height: 1.4;
    color: black;
    font-family: Avenir-medium;
  }@media only screen and (max-width: 959px) {
      .pbs-schedule-grid-subtitle2 {
        font-size: 18px;
      }
    }

  .pbs-schedule-synopsis {
    font-size: 18px;
    line-height: 1.4;
    color: #777;
    font-weight: normal;
    font-family: Avenir-Light;
    text-align: justify;
  }@media only screen and (max-width: 959px) {
      .pbs-schedule-synopsis {
        font-size: 16px;
      }
    }

   .select-pbs-schedule {
    border: 2px solid black;
    height: 44px;
    background: url(https://www.pbs12.org/images/schedule/drop-down-arrow.svg) right / 20px no-repeat #fff;
    background-position: calc(100% - 10px);
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    color: #01aeb4;
    font-size: 16px;
    font-weight: bold;
    width: 100%;
    padding: 5px 30px 5px 15px;
    font-family: Avenir-heavy;
  }
  .select-pbs-schedule-search-input {
    border: 2px solid black;
    height: 44px;
    background: url(https://www.pbs12.org/images/schedule/search-icon.svg) 99%/28px no-repeat #fff;
    /*url(https://www.pbs12.org/images/schedule/search-icon.svg) 99%/33px no-repeat #fff*/
    background-position: calc(100% - 10px);
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    color: #01aeb4;
    font-size: 16px;
    font-weight: bold;
    width: 100%;
    padding: 5px 30px 5px 15px;
    font-family: Avenir-heavy;
  }
  .select-pbs-schedule-search-input2 {
    border: 0;
    border-bottom: 1px solid rgba(0,0,0,.4);
    border-bottom: 1px solid rgb(1 174 180);
    height: 44px;
    background: url(https://www.pbs12.org/images/schedule/search-icon.svg) 99%/28px no-repeat rgba(0,0,0,.04);
    /*url(https://www.pbs12.org/images/schedule/search-icon.svg) 99%/33px no-repeat #fff*/
    background-position: calc(100% - 10px);
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    color: #01aeb4;
    font-size: 15px;
    width: 100%;
    padding: 5px 30px 5px 15px;
    font-family: Avenir-medium;
    background-color: white;
  }
  .select-pbs-schedule-search-input3 {
    border: 0;
    border-bottom: 1px solid rgba(0,0,0,.4);
    border-bottom: 1px solid rgb(1 174 180);
    height: 44px;
    background: url(https://www.pbs12.org/images/schedule/search-icon.svg) 99%/28px no-repeat rgba(0,0,0,.04);
    /*url(https://www.pbs12.org/images/schedule/search-icon.svg) 99%/33px no-repeat #fff*/
    background-position: calc(100% - 10px);
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    color: #01aeb4;
    font-size: 15px;
    width: 100%;
    padding: 5px 30px 5px 15px;
    font-family: Avenir-medium;
    background-color: white;
  }
  .select-pbs-schedule-dropdown {
    border: 0;
    border-bottom: 1px solid rgba(0,0,0,.4);
    border-bottom: 1px solid rgb(1 174 180);
    height: 44px;
    background: url(https://www.pbs12.org/images/schedule/arrow-down-select-icon.svg) 99%/28px no-repeat rgba(0,0,0,.04);
    /*url(https://www.pbs12.org/images/schedule/search-icon.svg) 99%/33px no-repeat #fff*/
    background-position: calc(100% - 10px);
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    color: #01aeb4;
    font-size: 15px;
    width: 100%;
    padding: 5px 30px 5px 15px;
    font-family: Avenir-medium;
    background-color: white;
  }


  .schedule-bg-hover:hover {
    background-color: #f7f5ed;
  }



  .channel-label {
    font-size: 9px;
    text-align: center;
    line-height: 1;
    margin: 5px 0 0px 0;
    color: rgba(0,0,0,.4);
    font-family: Avenir-medium;
  }

  .multichannel-subtitle {
    color: #777;
    /*font-size: 15px;*/
    font-size: 16px;
    /*font-size: 1.0vh;*/
    line-height: 1.4;
  }

  .mutichannel-time {
    text-align: right;
    color: black;
    font-family: Avenir-medium;
    font-size: 17px;
    color: red;
    margin-right: 5px;
  }

  *+.uk-grid-margin-small, .uk-grid+.uk-grid-row-small, .uk-grid+.uk-grid-small, .uk-grid-row-small>.uk-grid-margin, .uk-grid-small>.uk-grid-margin {
    margin-top: 0px;
  }

  .pbs-schedule-grid-title2 {
    cursor: pointer;
  }
  .pbs-schedule-grid-subtitle2{
    cursor: pointer;
  }
  .schedule-open{
    background: #f7f5ed;
  }

  .all-air-dates-progtitle {
    /*font-size: min(3.6vh,1.8vw);*/
    font-size: 48px;
    color: black;
    font-family: Avenir-Light;
    text-transform: uppercase;
    margin-bottom: 10px;
    line-height: 1;
  }@media only screen and (max-width: 959px) {
    .all-air-dates-progtitle {
      font-size: 32px;
      line-height: 1;
      text-align: center;
    }
  }


</style>
